// removed by extract-text-webpack-plugin
module.exports = {"login":"login___1h9ub"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login.module.less
// module id = 733
// module chunks = 0